import type { UseFormReturn } from 'react-hook-form';
import { Labeled } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { IFormMode } from '~/helpers/types';
import type { IArticleFormValues } from './ArticleForm';
import { FormCheckableDisclosure } from '~/components/atoms/fields/CheckableDisclosure';
import { FormDateField } from '~/components/atoms/fields/DateField';

export type IArticleFormUnpublicationSectionProps = IContainerProps & {
  mode: IFormMode;
  form: UseFormReturn<IArticleFormValues>;
  canSchedulePublication?: boolean;
};

export const ArticleFormUnpublicationSection: React.FC<
  IArticleFormUnpublicationSectionProps
> = ({ sx, form, canSchedulePublication }) => {
  const { t } = useTranslation();

  return (
    <FormCheckableDisclosure
      sx={sx}
      label={t('ArticleFormUnpublicationSection.schedule-unpublication')}
      control={form.control}
      name="unpublicationScheduled"
      initiallyExpanded={!!form.watch('unpublishAt')}
    >
      <Labeled
        label={t('ArticleFormUnpublicationSection.unpublish-at')}
        disabled={!form.watch('unpublicationScheduled')}
        required
      >
        <FormDateField
          name="unpublishAt"
          control={form.control}
          rules={{
            min: canSchedulePublication ? form.watch('publishAt') : undefined,
          }}
          defaultValue={new Date().toISOString()}
          future
        />
      </Labeled>
    </FormCheckableDisclosure>
  );
};
